import { projectSchema, versionSchema } from '@scalar-org/entities/project'
import { z } from 'zod'

import type { RequestService } from '../request'

export function projectApiFactory(requestService: RequestService) {
  /** Save session data on use signup */
  async function createProject(
    name: string,
    hideGuide: boolean,
    hideReference: boolean,
  ) {
    return await requestService.request({
      url: 'core/docs/create-project',
      method: 'post',
      data: {
        name,
        hideGuide,
        hideReference,
      },
      schema: projectSchema,
    })
  }

  /** Update hosted or sync project */
  async function updateProject(
    projectUid: string,
    data: Partial<{
      name: string
      loginPortalUid: string
      activeThemeId: string
      isPrivate: boolean
      accessGroups: string[]
    }>,
  ) {
    return await requestService.request({
      url: 'core/project/update',
      method: 'post',
      data: { projectUid, ...data },
      schema: z.null(),
    })
  }

  /** Delete a project and associated data */
  async function deleteProject(projectId: string) {
    return await requestService.request({
      url: 'core/docs/delete-project',
      method: 'delete',
      data: { projectId },
      schema: z.null(),
    })
  }

  async function changeProjectPrivacy(
    projectUid: string,
    makePrivate: boolean,
  ) {
    return await requestService.request({
      url: 'core/docs/project/change-privacy',
      method: 'post',
      data: { projectUid, makePrivate },
      schema: z.null(),
    })
  }

  async function createVersion(data: {
    name: string
    projectUid: string
    fromVersionUid?: string
  }) {
    return await requestService.request({
      url: 'core/docs/version',
      method: 'post',
      data,
      schema: versionSchema,
    })
  }

  return {
    createProject,
    deleteProject,
    changeProjectPrivacy,
    createVersion,
    updateProject,
  }
}
